// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"BlockCallToAction_blockContainer__kaO_o","blockCallToAction":"BlockCallToAction_blockCallToAction__5stEa"};